import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { TmaisUsersValidationSchema } from "../schemas/update.schema";
import { unFormatPhone } from "@/common/utils/unFormatters";

interface UseUpdateTmaisUserProps {
  id: string
  file: Blob | undefined
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateTmaisUser = ({id, file, onSuccess, onError}: UseUpdateTmaisUserProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateTmaisUser'],
    mutationFn: async (form: TmaisUsersValidationSchema) => {
      const payload = {
        ...form,
        profile_picture: file ? file : undefined,
        phone_attributes: {
          number: form?.phone ? unFormatPhone(form.phone) : undefined
        }
      }

      const {phone, ...cleanPayload} = payload

      return privateAxios.putForm(`/tmais/users/${id}`, { user: cleanPayload })
    },
    onSuccess,
    onError
  });
}

export default useUpdateTmaisUser
